import { VideoPresets } from 'livekit-client';

// The h540 preset caps at 800kbps, and call stats on the doctor app showed both sides
// pinned exactly there with no cpu or bandwidth pressure — the ceiling was ours. This
// keeps the preset's 25fps and only lifts the ceiling; LiveKit still adapts down when
// the link cannot carry it.
const VIDEO_MAX_BITRATE = 1_200_000;

const VIDEO_WIDTH = 960;

const VIDEO_HEIGHT = 540;

export const createRoomOptions = ({ videoDeviceId, audioDeviceId } = {}) => ({
	dynacast: false,
	publishDefaults: {
		degradationPreference: 'maintain-framerate',
		simulcast: false,
		videoCodec: 'vp8',
		videoEncoding: {
			...VideoPresets.h540.encoding,
			maxBitrate: VIDEO_MAX_BITRATE
		}
	},
	videoCaptureDefaults: {
		width: { ideal: VIDEO_WIDTH },
		height: { ideal: VIDEO_HEIGHT },
		...(videoDeviceId && { deviceId: { ideal: videoDeviceId } })
	},
	audioCaptureDefaults: {
		...(audioDeviceId && { deviceId: { ideal: audioDeviceId } })
	}
});
